/* 🤖 this file was generated by svg-to-ts */
export const mgcIconAlbum2Filled: {
  name: 'album-2-filled';
  data: string;
} = {
  name: 'album-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.643 3.069C5.291 3.193 5 3.614 5 4c0 .242.119.521.299.701C5.621 5.023 5.097 5 12 5s6.379.023 6.701-.299a.984.984 0 0 0 0-1.402c-.323-.323.205-.299-6.718-.296-5.475.003-6.183.01-6.34.066M3.197 6.055a1.511 1.511 0 0 0-1.082 1.233c-.039.238.01.559.88 5.766.894 5.355.924 5.523 1.062 5.813.26.548.821.98 1.418 1.092.297.056 12.753.056 13.05 0a2.035 2.035 0 0 0 1.41-1.08c.147-.299.153-.329 1.07-5.82.87-5.211.919-5.533.88-5.771a1.487 1.487 0 0 0-1.094-1.231c-.293-.078-17.305-.08-17.594-.002"/></svg>`
};
